module.exports = __webpack_public_path__ + "static/media/MoveTynaxBlue250-6.f9ec57c7.png";